import { useEffect } from 'react';
import { Map as MaplibreMap } from 'maplibre-gl';

/**
 * Gestisce l'evento 'styleimagemissing' della mappa MapLibre,
 * aggiungendo un'immagine di fallback (un cerchio rosso) quando un'icona richiesta non è trovata.
 * @param map L'istanza della mappa MapLibre.
 */
export function useMissingImageFallback(map: MaplibreMap | null) {
    useEffect(() => {
        if (!map) return; // Non fare nulla se la mappa non è pronta

        // --- 1. Crea Immagine di Fallback (Cerchio Rosso 10x10) ---
        const width = 10;
        const height = 10;
        const bytesPerPixel = 4; // RGBA
        const data = new Uint8ClampedArray(width * height * bytesPerPixel);

        for (let x = 0; x < width; x++) {
            for (let y = 0; y < height; y++) {
                const offset = (y * width + x) * bytesPerPixel;
                // Semplice logica per un cerchio (distanza dal centro)
                const dx = x - width / 2 + 0.5;
                const dy = y - height / 2 + 0.5;
                const distanceSquared = dx * dx + dy * dy;
                const radiusSquared = (width / 2) * (width / 2);

                if (distanceSquared <= radiusSquared) {
                    data[offset + 0] = 255; // R (Rosso)
                    data[offset + 1] = 0;   // G
                    data[offset + 2] = 0;   // B
                    data[offset + 3] = 255; // A (Opaco)
                } else {
                    // Trasparente fuori dal cerchio
                    data[offset + 0] = 0;
                    data[offset + 1] = 0;
                    data[offset + 2] = 0;
                    data[offset + 3] = 0;   // A (Trasparente)
                }
            }
        }
        // Assicuriamo la compatibilità con il tipo atteso da addImage
        const fallbackImageData: ImageData = {
            width: width,
            height: height,
            data: data,
            colorSpace: 'srgb' // Proprietà richiesta dal tipo ImageData
        };
        const addImageOptions = { pixelRatio: 1 }; // La nostra immagine è definita pixel per pixel

        // --- 2. Definisci e Aggiungi Event Listener ---
        const missingImageHandler = (e: { id: string }) => {
            const imageId = e.id;

            // Controlla se l'immagine di fallback è GIA' stata aggiunta per questo ID
            if (map && !map.hasImage(imageId)) {
                try {
                    // Aggiungi l'immagine di fallback generata alla mappa
                    map.addImage(imageId, fallbackImageData as any, addImageOptions);
                    // map.triggerRepaint(); // Decommenta se necessario
                } catch (error) {
                }
            } else if (map && map.hasImage(imageId)) {
                 // Immagine già presente (potrebbe essere stata aggiunta nel frattempo o è il nostro fallback)
            } else {
            }
        };

        map.on('styleimagemissing', missingImageHandler);

        // --- 3. Pulizia Listener ---
        return () => {
            if (map && map.getStyle()) {
                try {
                    map.off('styleimagemissing', missingImageHandler);
                } catch (error) {
                }
            } else {
            }
        };

    }, [map]); // Dipendenza: riesegui solo quando l'istanza della mappa cambia
}